import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import { readMenuAll } from 'apis/restaurant-api/merchant-admin/menu2/api';
import { Category } from 'apis/restaurant-api/merchant-admin/menu2/types';
import { localize } from 'common/utils';

type UseDiscountedItemProps = {
  menuId: string;
  categoryId?: string;
};
export const useDiscountedCategory = ({ menuId, categoryId }: UseDiscountedItemProps) => {
  const { locale } = useIntl();
  const { data, isFetching, error } = useQuery(['read-menu-all', menuId], () => readMenuAll(menuId), {
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  const findCategoryByIdRecursive = (categories: Category[]): Category | undefined =>
    categories.reduce<Category | undefined>((matchingChild, category) => {
      if (matchingChild) {
        return matchingChild;
      }
      if (category.id === categoryId) {
        return category;
      }
      return findCategoryByIdRecursive(category.child_categories);
    }, undefined);

  const category = data?.menu.categories ? findCategoryByIdRecursive(data.menu.categories) : undefined;

  return {
    discountedCategory: category
      ? {
          ...category,
          name: localize(category.name, locale).trim(),
          description: localize(category.description, locale),
        }
      : undefined,
    isFetching,
    error,
  };
};
